<template>
  <div :class="['container', `pageNumber-${currentPageNumber}`, `stageNumber-${stageNumber}`, ...classes]">
    <template v-if="rightPan">
      <div class="left-section1">
        <div class="survey-body" ref="surveyBodyRef">
          <div class="text-center hideElement" style="padding-top: 30px;">
            <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;">
          </div><br>
          <div class="bgWhite">
            <!-- <div class="sleek-progress-container">
              <p class="sleek-progress-text">Progress: ~{{ surveyProgressByQuestion }}% </p>
              <div class="sleek-progress-bar-bg"> 
                <div class="sleek-progress-bar" :style="{ width: surveyProgressByQuestion + '%' }">
                  <img v-if="getProgressBarImageSrc" :src="getProgressBarImageSrc" class="progress-bar-icon" />
                </div>
              </div>
            </div> -->
            <div class="sleek-progress-container">
              <p class="sleek-progress-text">Progress: ~{{ surveyProgressByQuestion }}%</p>

              <div class="sleek-progress-bar-bg">
                <div class="sleek-progress-bar" :style="{ width: surveyProgressByQuestion + '%' }"></div>
                
                <img
                  v-if="getProgressBarImageSrc"
                  :src="getProgressBarImageSrc"
                  class="progress-bar-icon"
                  :style="{ left: `calc(${surveyProgressByQuestion}% - 45px)` }"
                />
              </div>
            </div>

          </div>

          <div v-if="currentQuestions.length" :class="['questionBody', gridStyle]">
            <p v-if="shouldShowPageHeader" class="questionHeader"><strong>{{ pageHeader }}</strong></p>
            <QuestionComponent
              v-for="question in currentQuestions"
              :key="question.id"
              :question="question"
              :showValidation="showValidation"
              @validate="validatePage"
              @validation-status="forwardValidation"
            />
            <br>
            <div class="col-sm-12 text-center hideElement extraSpace">
              <img :src="getImageSrc(currentPageNumber)">
            </div>
          </div><br>
          <div class="text-center hideElement">
            <small class="text-gray powered">Powered by</small>
            <img :src="require('@/assets/img/CIC.png')" alt="Logo" style="height: 30px;">
          </div>
        </div>
        <div class="navigation">
          <button @click="prevPage" :disabled="!hasPreviousPage" class="btn-prev pull-left">
            <i class="fas fa-arrow-left"></i>&nbsp;&nbsp;Previous
          </button>
          <button @click="nextPage" v-if="hasNextPage" class="btn-next pull-right">
            Next&nbsp;&nbsp;<i class="fas fa-plane"></i>
          </button>
          <button @click="completeStage" v-if="!hasNextPage" class="btn-next pull-right">
            Continue&nbsp;&nbsp;<i class="fas fa-plane"></i>
          </button>
        </div>
      </div>

      <div class="right-section1">
        <div class="asideHead">
          <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;">
        </div>
        <div class="asideBody text-center">
          <img :src="getImageSrc(currentPageNumber)" style="width: 300px;">
            <h2 v-html="getImageContent(currentPageNumber) || 'No Content'"></h2>
        </div>
        <div class="asideFoot">
          <small class="text-gray powered">Powered by</small>
          <img :src="require('@/assets/img/CIC.png')" style="height: 30px;">
        </div>
      </div>
    </template>

    <template v-else>
      <div class="left-section">
        <div class="asideHead">
          <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;">
        </div>
        <div class="asideBody text-center">
          <img :src="getImageSrc(currentPageNumber)" style="width: 300px;">
           <h2 v-html="getImageContent(currentPageNumber) || 'No Content'"></h2>
        </div>
        <div class="asideFoot">
          <small class="text-gray powered">Powered by</small>
          <img :src="require('@/assets/img/CIC.png')" style="height: 30px;">
        </div>
      </div>

      <div class="right-section">
        <div class="survey-body" ref="surveyBodyRef">
          <div class="text-center hideElement" style="padding-top: 30px;">
            <img :src="require('@/assets/img/logo.png')" alt="Logo" style="height: 60px;">
          </div><br>
          <div class="bgWhite">
            <div class="sleek-progress-container">
              <p class="sleek-progress-text">Progress: ~{{ surveyProgressByQuestion }}%</p>

              <div class="sleek-progress-bar-bg">
                <div class="sleek-progress-bar" :style="{ width: surveyProgressByQuestion + '%' }"></div>
                
                <img
                  v-if="getProgressBarImageSrc"
                  :src="getProgressBarImageSrc"
                  class="progress-bar-icon"
                  :style="{ left: `calc(${surveyProgressByQuestion}% - 45px)` }"
                />
              </div>
            </div>


          </div>

          <div v-if="currentQuestions.length" :class="['questionBody', gridStyle]">
            <p v-if="shouldShowPageHeader" class="questionHeader"><strong>{{ pageHeader }}</strong></p>
            <QuestionComponent
              v-for="question in currentQuestions"
              :key="question.id"
              :question="question"
              :showValidation="showValidation"
              @validate="validatePage"
              @validation-status="forwardValidation"
            />
            <br>
            <div class="col-sm-12 text-center hideElement extraSpace">
              <img :src="getImageSrc(currentPageNumber)">
            </div>
          </div><br>
          <div class="text-center hideElement">
            <small class="text-gray powered">Powered by</small>
            <img :src="require('@/assets/img/CIC.png')" alt="Logo" style="height: 30px;">
          </div>
        </div>
        <div class="navigation">
          <button @click="prevPage" :disabled="!hasPreviousPage" class="btn-prev pull-left">
            <i class="fas fa-arrow-left"></i>&nbsp;&nbsp;Previous
          </button>
          <button @click="nextPage" v-if="hasNextPage" class="btn-next pull-right">
            Next&nbsp;&nbsp;<i class="fas fa-plane"></i>
          </button>
          <button @click="completeStage" v-if="!hasNextPage" class="btn-next pull-right">
            Continue&nbsp;&nbsp;<i class="fas fa-plane"></i>
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import surveyService from "@/services/surveyService";
import QuestionComponent from "./QuestionComponent.vue";
import { toRaw } from 'vue';

export default {
  components: {
    QuestionComponent,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const stageNumber = ref(null);
    const allStageQuestions = ref([]);
    const currentPageNumber = ref(1);
    const displayPageNumbers = ref([]); // Pages with questions
    const isCurrentPageValid = ref(true);
    const isHavingErrorsFromQuestions = ref(false);
    const showValidation = ref(false);
    const pageHeader = ref('');
    const gridStyle = ref('');
    const rightPan = ref('');
    const classes = ref([]);
    const surveyBodyRef = ref(null);
    const skipPages = ref(null);
    let isProgrammaticUpdate = false;

    // Computed property to check if Q19 header should be shown
    const shouldShowPageHeader = computed(() => {
      if (!pageHeader.value) return false;
      
      // If the header contains "19." it's the Q19 header
      if (pageHeader.value.includes('19.')) {
        // Only show if there are Q19 questions visible
        const hasQ19Questions = currentQuestions.value.some(q => q.id && q.id.toString().startsWith('19'));
        console.log('🎯 Q19 Header Check:', {
          pageHeader: pageHeader.value,
          currentQuestions: currentQuestions.value.map(q => q.id),
          hasQ19Questions,
          willShowHeader: hasQ19Questions
        });
        return hasQ19Questions;
      }
      
      // For other headers, always show
      return true;
    });


    const pageCompletion = ref(0);
    const surveyProgressByQuestion = ref(0);

    const updatePageCompletion = () => {
      const currentPageNumberValue = displayPageNumbers.value[currentPageNumber.value - 1];
      pageCompletion.value = surveyService.calculatePageCompletion(stageNumber.value, currentPageNumberValue);
    };

    const questionsByPage = computed(() => {
      const grouped = {};
      allStageQuestions.value.forEach((q) => {
        if (!grouped[q.page]) {
          grouped[q.page] = [];
        }
        grouped[q.page].push(q);
      });
      return grouped;
    });

    const currentQuestions = computed(() => {
      const currentPage = displayPageNumbers.value[currentPageNumber.value - 1];
      return (questionsByPage.value[currentPage] || []).filter((q) => {
        if (!q.condition) {
          return true;
        }

        const conditions = Array.isArray(q.condition) ? q.condition : [q.condition];
        return conditions.every((cond) => {
          const answer = surveyService.getAnswer(cond.question_id);
          const rawAnswer = toRaw(answer);

          if (Array.isArray(rawAnswer)) {
            const selectedKeys = rawAnswer.map(item => item?.key ?? item);
            const isMatch = cond.single
              ? selectedKeys.length === 1 && selectedKeys[0]?.toString() === cond.value?.toString()
              : selectedKeys.some(key => key?.toString() === cond.value?.toString());
            return cond.reverse ? !isMatch : isMatch;
          }

          // Extract the actual value from object or string
          let answerValue = rawAnswer;
          if (rawAnswer && typeof rawAnswer === 'object') {
            answerValue = rawAnswer.value || rawAnswer.key || rawAnswer;
          }
          
          // Convert to string for comparison
          const answerStr = String(answerValue || '');
          const conditionStr = String(cond.value || '');
          
          // Exact match — no prefix matching
          const isMatch = answerStr === conditionStr;
          
          console.log(`🔍 Condition check for Q${q.id}:`, {
            questionId: cond.question_id,
            rawAnswer,
            answerValue,
            answerStr,
            conditionStr,
            isMatch,
            reverse: cond.reverse,
            result: cond.reverse ? !isMatch : isMatch
          });
          
          return cond.reverse ? !isMatch : isMatch;
        });
      });
    });

    const initializeDisplayPages = () => {
      displayPageNumbers.value = Object.keys(questionsByPage.value)
        .filter(page => {
          const pageQuestions = questionsByPage.value[page];
          return pageQuestions.some(q => !q.condition || checkCondition(q));
        })
        .map(Number)
        .sort((a, b) => a - b);
      applyPageSkipping(); // Apply skipping logic after initial page setup
    };

    const applyPageSkipping = () => {
      const answerToQuestion8 = surveyService.getAnswer(8); // Assuming question ID is 8
      
      const pagesToSkip = getPagesToSkip(answerToQuestion8); // Function to determine pages to skip
      console.log("Pages to skip based on answer to question 8:", pagesToSkip);
      
      skipPages.value = {stage:stageNumber.value, pages:pagesToSkip};
      
      /*if (pagesToSkip && pagesToSkip.length > 0) {
        displayPageNumbers.value = displayPageNumbers.value.filter(pageNumber => !pagesToSkip.includes(pageNumber));
        // Ensure current page number is valid after skipping
        if (!displayPageNumbers.value.includes(currentPageNumber.value)) {
          currentPageNumber.value = displayPageNumbers.value[0] || 1;
          router.replace({ name: "SurveyStage", params: { stageNumber: stageNumber.value }, query: { pageNumber: currentPageNumber.value } });
        }
      }*/
    };

    // Function to define which pages to skip based on the answer to question 8
    // Only applies to stage 2 (where Q8/Q9 live) — never skip pages in other stages
    const getPagesToSkip = (answer) => {
      if (stageNumber.value !== 2) return []; // Q8 page-skip only applies to stage 2
      if (Array.isArray(answer)) {
        const hasX1Key = answer.some(item => item?.key === 'Traveling alone');
        if (hasX1Key) {
          isProgrammaticUpdate = true;
          surveyService.setAnswer(9, {
            'Number of adults': 1,
            'Number of children under 18 years old': 0
          });
          
          // Delay resetting the flag to let Vue settle
          setTimeout(() => {
            isProgrammaticUpdate = false;
          }, 0);

          return [2];
        }
      }
      return [];
    };


    const checkCondition = (q) => {
      const condition = q.condition;
      if (!condition) return true;

      // Handle array conditions - all must pass
      if (Array.isArray(condition)) {
        return condition.every(cond => {
          let conditionAnswer = surveyService.getAnswer(cond.question_id);
          if (conditionAnswer && typeof conditionAnswer === 'object') {
            conditionAnswer = conditionAnswer.value || conditionAnswer.key || conditionAnswer;
          }
          const answerStr = String(conditionAnswer || '');
          const conditionStr = String(cond.value || '');
          const isMatch = answerStr === conditionStr;
          return cond.reverse ? !isMatch : isMatch;
        });
      }

      let conditionAnswer = surveyService.getAnswer(condition.question_id);
      
      // Extract value from object if needed
      if (conditionAnswer && typeof conditionAnswer === 'object') {
        conditionAnswer = conditionAnswer.value || conditionAnswer.key || conditionAnswer;
      }
      
      // Convert to string for comparison
      const answerStr = String(conditionAnswer || '');
      const conditionStr = String(condition.value || '');
      
      // Exact match only
      const isMatch = answerStr === conditionStr;
      
      return condition.reverse ? !isMatch : isMatch;
    };

    const skipEmptyDisplayPages = () => {
      while (currentPageNumber.value <= displayPageNumbers.value.length && currentQuestions.value.length === 0) {
        currentPageNumber.value++;
        router.push({ name: "SurveyStage", params: { stageNumber: stageNumber.value }, query: { pageNumber: currentPageNumber.value } });
      }
    };

    const totalDisplayPages = computed(() => displayPageNumbers.value.length);
    const hasPreviousPage = computed(() => currentPageNumber.value > 1);
    const hasNextPage = computed(() => currentPageNumber.value < totalDisplayPages.value);

    const validatePage = () => {
      isCurrentPageValid.value = currentQuestions.value.every((q) => {
        const answer = surveyService.getAnswer(q.id);

        if (q.required && (answer === undefined || answer === "")) {
          return false;
        }

        if (q?.validators?.pattern && answer && !new RegExp(q.validators.pattern).test(answer)) {
          return false;
        }

        if (q.type === "table-slider" && q.rows && answer) {
          const totalPercentage = answer.reduce((acc, val) => acc + Number(val), 0);
          if (totalPercentage !== 100 && totalPercentage !== 0) {
            return false;
          }
        }

        if(isHavingErrorsFromQuestions.value) {
          return false; // If there are errors from questions, skip validation
        }
        return true;
      });
    };

    const forwardValidation = (isValid) => {
      isHavingErrorsFromQuestions.value = isValid;
    };

    // --- UPDATED prevPage function ---
    const prevPage = () => {
      if (!hasPreviousPage.value) return; // Use the computed property to check if a previous page exists

      let previousPageRoute = currentPageNumber.value - 1;
      const pagesToSkip = skipPages.value?.stage === stageNumber.value ? skipPages.value.pages : [];

      // Find the actual previous page, skipping any designated pages
      while (previousPageRoute >= 1 && pagesToSkip.includes(previousPageRoute)) {
        previousPageRoute--;
      }

      if (previousPageRoute >= 1) {
        router.push({ name: "SurveyStage", params: { stageNumber: stageNumber.value }, query: { pageNumber: previousPageRoute } });
      }
    };
    // --- END UPDATED prevPage function ---

    const nextPage = () => {
      console.log('Answers:', surveyService.getAnswers());
      console.log('Current Page Number:', currentPageNumber.value);
      showValidation.value = true;
      validatePage();
      if (isCurrentPageValid.value) {
        showValidation.value = false;
        
        // CRITICAL: Check for Q7a Government/Military termination BEFORE navigating
        const answers = surveyService.getAnswers();
        const q7aAnswer = answers?.["7a"];
        
        // Check for Government/Military selection (value "8")
        // The answer can be stored as string "8", object with key "8", or object with key "Government/Military"
        let isGovtOrMilitary = false;
        if (q7aAnswer) {
          if (typeof q7aAnswer === 'string') {
            isGovtOrMilitary = q7aAnswer === "8";
          } else if (typeof q7aAnswer === 'object') {
            isGovtOrMilitary = q7aAnswer.key === "8" || q7aAnswer.key === "Government/Military" || q7aAnswer.value === "8";
          }
        }
        
        console.log('🔍 Q7a Termination Check:', {
          q7aAnswer,
          answerType: typeof q7aAnswer,
          isGovtOrMilitary
        });
        
        if (isGovtOrMilitary) {
          console.log('🛑 Q7a Government/Military selected - terminating survey');
          // Set termination flag and redirect to thank you page
          localStorage.setItem('surveyTerminationReason', 'government-military');
          localStorage.setItem('surveyTerminationMessage', 'Thank you for your time. This survey is not applicable for government/military travel.');
          surveyService.setSurveyCompleted();
          router.push({ name: "SurveyEnd" });
          return;
        }
        
        let nextPageRoute = currentPageNumber.value + 1;

        // Check if there are pages to skip for the current stage
        const pagesToSkip = skipPages.value?.stage === stageNumber.value ? skipPages.value.pages : [];

        // Find the next page that is NOT in the pagesToSkip array
        while (pagesToSkip.includes(nextPageRoute) && nextPageRoute <= totalDisplayPages.value) {
          nextPageRoute++;
        }

        if (nextPageRoute <= totalDisplayPages.value) {
          router.push({ name: "SurveyStage", params: { stageNumber: stageNumber.value }, query: { pageNumber: nextPageRoute } });
          surveyService.saveProgress();
        } else {
          completeStage();
        }
      }
    };

    const completeStage = () => {
      showValidation.value = true;
      validatePage();
      if (isCurrentPageValid.value) {
        showValidation.value = false;
        
        // CRITICAL: Check for Q7a Government/Military termination BEFORE completing stage
        const answers = surveyService.getAnswers();
        const q7aAnswer = answers?.["7a"];
        
        // Check for Government/Military selection (value "8")
        // The answer can be stored as string "8", object with key "8", or object with key "Government/Military"
        let isGovtOrMilitary = false;
        if (q7aAnswer) {
          if (typeof q7aAnswer === 'string') {
            isGovtOrMilitary = q7aAnswer === "8";
          } else if (typeof q7aAnswer === 'object') {
            isGovtOrMilitary = q7aAnswer.key === "8" || q7aAnswer.key === "Government/Military" || q7aAnswer.value === "8";
          }
        }
        
        console.log('🔍 Q7a Stage Completion Check:', {
          q7aAnswer,
          answerType: typeof q7aAnswer,
          isGovtOrMilitary
        });
        
        if (isGovtOrMilitary) {
          console.log('🛑 Q7a Government/Military selected - terminating survey at stage completion');
          // Set termination flag and redirect to thank you page
          localStorage.setItem('surveyTerminationReason', 'government-military');
          localStorage.setItem('surveyTerminationMessage', 'Thank you for your time. This survey is not applicable for government/military travel.');
          surveyService.setSurveyCompleted();
          router.push({ name: "SurveyEnd" });
          return;
        }
        
        if(stageNumber.value === 6) {
            router.push({ name: "SuccessPage", params: { stageNumber: stageNumber.value } });
        }else {
          setTimeout(() => {
            const stageNo = parseInt(route.params.stageNumber) + 1;
            stageNumber.value = stageNo; // Update stageNumber here
              surveyService.saveProgress();
            router.push({ name: "SurveyStage", params: { stageNumber: stageNo }, query: { pageNumber: 1 } });
          }, 300);
        }
        
       
      }
    };

    const getImageData = (pageNum) => {
      const surveyStage = surveyService.getStage(stageNumber.value);
      return surveyStage?.page_options?.images?.[pageNum];
    };

    const getImageSrc = (pageNum) => {
      const image = getImageData(pageNum);
      return image ? require(`@/${image.imageUrl}`) : require('@/assets/img/asideImage/1.gif');
    };

    const getImageContent = (pageNum) => {
      const image = getImageData(pageNum);
      return image?.caption ?? null;
    };

    /*const getImageBgColor = (pageNum) => {
      const image = getImageData(pageNum);
      return image?.bgcolor ?? "#ffffff"; // default bg
    };*/


    const getProgressBarImageSrc = computed(() => {
      if (surveyProgressByQuestion.value > 0 && surveyService) {
        try {
          const img = require(`@/assets/img/flight_icons/${surveyService.getImageByStage(stageNumber.value, currentPageNumber.value) || '01.png'}`);
          return img;
        } catch (error) {
          console.error('Error loading progress bar image:', error);
          return null;
        }
      }
      return null;
    });

    const totalQuestionsInSurvey = computed(() => {
      return surveyService ? surveyService.getTotalQuestions() : 0;
    });
    
    const answeredQuestionsInSurvey = computed(() => {
      return surveyService ? Object.keys(surveyService.getAnswers()).length : 0;
    });
    
    const overallProgress = computed(() => {
      if (totalQuestionsInSurvey.value > 0) {
        return Math.round((answeredQuestionsInSurvey.value / totalQuestionsInSurvey.value) * 100);
      }
      return 0;
    });

    const updateSurveyProgressByQuestion = () => {
      if (currentQuestions.value.length > 0) {
        surveyProgressByQuestion.value = surveyService.calculateProgressByCurrentQuestionId(currentQuestions.value[0].id);
        if(stageNumber.value === 6 && currentPageNumber.value === 5) {
          surveyProgressByQuestion.value = 98; // Reset progress for the first page
        }
      } else {
        surveyProgressByQuestion.value = 0;
      }
    };

    // --- New function to handle stage initialization logic ---
    const initializeStage = (newStageNumber) => {
      stageNumber.value = newStageNumber;
      allStageQuestions.value = surveyService.getQuestionsByStage(stageNumber.value);

      try {
        const surveyStage = surveyService.getStage(stageNumber.value);
        if (surveyStage) {
          onPageChange();
        }
      } catch (error) {
        console.error(error);
      }

      if (allStageQuestions.value.length === 0) {
        router.push({ name: "SurveyStage", params: { stageNumber: stageNumber.value + 1 }, query: { pageNumber: 1 } });
        return;
      }

      // Ensure currentPageNumber is valid for the new stage
      if (isNaN(parseInt(route.query.pageNumber))) {
        router.replace({
          name: "SurveyStage",
          params: { stageNumber: stageNumber.value },
          query: { pageNumber: 1 },
        });
        currentPageNumber.value = 1; // Explicitly set it here too
      } else {
        currentPageNumber.value = parseInt(route.query.pageNumber);
      }

      initializeDisplayPages();
      skipEmptyDisplayPages();
      updatePageCompletion();
      updateSurveyProgressByQuestion();
    };

    onMounted(() => {
      if (surveyService.isSurveySubmitted()?.restrictSubmission) {
        router.push({ name: "SurveyEnd" });
        return;
      }
      initializeStage(parseInt(route.params.stageNumber)); // Initial call on mount
    });

    // Watch for changes in the stageNumber route parameter
    watch(
      () => route.params.stageNumber,
      (newStage, oldStage) => {
        if (newStage !== oldStage) {
          initializeStage(parseInt(newStage)); // Re-initialize the stage when the parameter changes
        }
      }
    );

    watch(currentPageNumber, () => {
      onPageChange();
      if (surveyBodyRef.value) {
        surveyBodyRef.value.scrollTop = 0;
      }
      updatePageCompletion();
      updateSurveyProgressByQuestion();
    });

    watch(
      () => route.query.pageNumber,
      (newVal) => {
        currentPageNumber.value = parseInt(newVal) || 1;
        skipEmptyDisplayPages();
        updatePageCompletion();
        updateSurveyProgressByQuestion();
      }
    );

    watch(() => surveyService.getAnswers(), () => {
      if (isProgrammaticUpdate) return; // 👈 Ignore programmatic update
      updatePageCompletion();
      applyPageSkipping();
      initializeDisplayPages(); // Re-evaluate pages when answers change (e.g. US resident condition)
    }, { deep: true });


    const onPageChange = () => {
      console.log('onPageChange called with stageNumber:', stageNumber.value); // Use stageNumber.value
      try {
        if (surveyService.isSurveySubmitted()?.restrictSubmission) {
          router.push({ name: "SurveyEnd" });
          return;
        }

        // Check for survey termination conditions — only on stages 2+ where Q6/Q7a are relevant
        // Do NOT check on stage 6 (final stage) to prevent false termination after Q18
        if (stageNumber.value && stageNumber.value <= 5 && surveyService.isPageBrekable()) {
          const answers = surveyService.getAnswers();
          const q7aAnswer = answers?.["7a"];
          
          // Check for Government/Military selection (value "8")
          // The answer can be stored as string "8", object with key "8", or object with key "Government/Military"
          let isGovtOrMilitary = false;
          if (q7aAnswer) {
            if (typeof q7aAnswer === 'string') {
              isGovtOrMilitary = q7aAnswer === "8";
            } else if (typeof q7aAnswer === 'object') {
              isGovtOrMilitary = q7aAnswer.key === "8" || q7aAnswer.key === "Government/Military" || q7aAnswer.value === "8";
            }
          }
          
          console.log('🔍 Q7a Page Change Check:', {
            q7aAnswer,
            answerType: typeof q7aAnswer,
            isGovtOrMilitary
          });
          
          if (isGovtOrMilitary) {
            // Handle Q7a Government/Military termination - go to thank you page
            console.log('🛑 Q7a Government/Military termination - redirecting to thank you page');
            surveyService.terminateSurveyForGovernmentMilitary();
            return;
          } else {
            // Handle other termination conditions (like Q6 limits) - submit survey
            surveyService.submitSurvey();
            return;
          }
        }

        const surveyStage = surveyService.getStage(stageNumber?.value);
        pageHeader.value = surveyStage?.page_options?.header?.[currentPageNumber?.value] || '';
        gridStyle.value = surveyStage?.page_options?.grid_style?.[currentPageNumber?.value] || '';
        rightPan.value = surveyStage?.page_options?.['right-pan'] ?? false;
        classes.value = surveyStage?.page_options?.['classes'] ?? [];
        isHavingErrorsFromQuestions.value = false; // Reset error state on page change
        showValidation.value = false; // Reset validation state on page change
        updateSurveyProgressByQuestion();
      } catch (error) {
        console.error("Error in onPageChange:", error);
      }
    };

    return {
      stageNumber,
      currentQuestions,
      currentPageNumber,
      totalDisplayPages,
      hasPreviousPage,
      hasNextPage,
      isCurrentPageValid,
      showValidation,
      prevPage,
      nextPage,
      completeStage,
      validatePage,
      pageHeader,
      shouldShowPageHeader,
      getImageSrc,
      gridStyle,
      getImageContent,
      rightPan,
      classes,
      surveyBodyRef,
      overallProgress,
      pageCompletion,
      surveyProgressByQuestion,
      forwardValidation,
      getProgressBarImageSrc
    };
  },
};
</script>

<style scoped>
/* Your styles remain the same */
.bgWhite {
  background-color: white;
  padding: 1px 9px;
  border-radius: 5px;
  margin-bottom: 15px;
}
.sleek-progress-container {
  margin-bottom: 15px;
}

.sleek-progress-text {
  font-size: 0.9em;
  color: #555;
  margin-bottom: 5px;
}

.sleek-progress-bar-bg {
  position: relative;
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 5px;
  overflow: visible; /* 👈 allows image to move beyond bar */
}

.sleek-progress-bar {
  background-color: #007bff;
  height: 8px;
  border-radius: 5px;
  transition: width 0.3s ease-in-out;
}

.progress-bar-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-52%);
  height: 114px; /* 👈 adjust height */
  width: 153px;  /* 👈 adjust width */
  transition: left 0.3s ease-in-out;
  z-index: 2;
  pointer-events: none; /* avoids accidental hover/click issues */
}
</style>